enum MATERIAL_TYPES {
  PRESENTATION_PDF = 'presentation_pdf',
  PRESENTATION_REVEAL = 'presentation_reveal',
  ARTICLE = 'article',
  SNIPPET = 'snippet',
  QUIZ = 'quiz',
  EXERCISE = 'exercise',
  ATTACHMENT = 'attachment',
}

export default MATERIAL_TYPES;
